/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const ExpandedPopup = styled.div({
  width: '384px',
  maxHeight: '400px',
  overflowY: 'auto',
  position: 'sticky',
  boxShadow: token('elevation.shadow.overlay'),
  scrollbarWidth: 'none',
  MsOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const TopHeaderSection = styled.div({
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'sticky',
  height: '36px',
  paddingLeft: '16px',
  top: 0,
  border: `0.5px solid ${token('color.border')}`,
  background: token('color.background.input'),
  zIndex: 185,
  color: token('color.text.subtlest'),
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.bold'),
  cursor: 'pointer',
});

export const BottomHeaderSection = styled.div({
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'sticky',
  height: '36px',
  paddingLeft: '16px',
  top: '36px',
  bottom: 0,
  border: `0.5px solid ${token('color.border')}`,
  background: token('color.background.input'),
  zIndex: 185,
  color: token('color.text.subtlest'),
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.bold'),
  cursor: 'pointer',
});

export const CommentPreview = styled.div({
  boxSizing: 'border-box',
  height: '84px',
  border: `0.5px solid ${token('color.border')}`,
  padding: '16px 18px',
  gap: '8px',
  position: 'sticky',
  zIndex: 184,
  overflow: 'clip',
  cursor: 'pointer',
  '&:hover, &:focus': {
    backgroundColor: token('color.background.accent.gray.subtlest'),
  },
  '&:active': {
    backgroundColor: token('color.background.selected'),
  },
});

export const EmptyCommentSection = styled.div({
  height: '52px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontWeight: token('font.weight.bold'),
  border: `0.5px solid ${token('color.border')}`,
});

export const CommentPreviewHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const MetadataAndAvatar = styled.div({
  display: 'flex',
  gap: '6px',
  flexGrow: 1,
});

export const CommentMetadata = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
});

export const FileDateDescription = styled.div({
  display: 'flex',
  font: token('font.body.small'),
  color: token('color.text.subtlest'),
  '> span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '305px',
  },
});

export const UsernameAndOutdatedLozenge = styled.div<{
  commentIsOutdated: boolean;
}>(props => ({
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center',
  '> span:first-child': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: props.commentIsOutdated ? '242px' : '305px',
  },
}));

export const CollapseExpandButton = styled.button({
  background: 'none',
  border: 'none',
  color: 'inherit',
  font: 'inherit',
  marginLeft: 'auto',
});

export const NoPreviewAvailable = styled.div({
  color: token('color.text.subtlest'),
  fontStyle: 'italic',
});
